// eslint-disable-next-line @typescript-eslint/object-curly-spacing
export const sectionIds = {
    productsId: 'products',
    storiesId: 'stories',
    aboutId: 'about',
    contactId: 'contact',
};
